'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intlPage = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _actions = require('../actions');

var _dtm = require('./dtm');

var _seo = require('./seo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {};

var intlPage = exports.intlPage = function intlPage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _actions.NEED_IDLE_MONITOR:
      return (0, _extends3.default)({}, state, {
        needIdleMonitor: action.value
      });
    case _actions.PAGE_DATA_RECEIVED:
      return (0, _extends3.default)({}, state, action.payload, {
        dtm: (0, _dtm.dtm)(state.dtm, action),
        seo: (0, _seo.seo)(state.seo, action),
        needIdleMonitor: false,
        httpStatus: 200
      });
    case _actions.INTL_PAGE_CLEANUP:
      return initialState;
    default:
      return state;
  }
};